import React from 'react';
import SelectInput from "./SelectInput";
import TextInput from "./TextInput";

export default function AddressInput({
    label = "Adresse",
    placeholders = ['', '', '', 'Sélectionner un pays'],
    required = false,
    address = {
        street: "",
        postalCode: "",
        city: "",
        country: "",
    },
    onChange,
    disabled = false,
    errors = ['', '', '', ''],
    countries = [],
}) {
    const handleChange = (field, value) => {
        if (onChange) {
            onChange({ ...address, [field]: value });
        }
    };

    return (
        <div>
            <h2 className="text-lg font-bold mb-2">{label}</h2>
            <TextInput
              id="street"
              label="Rue et numéro"
              disabled={disabled}
              value={address.street}
              placeholder={placeholders[0]}
              error={errors[0]}
              required={required}
              onChange={value => handleChange("street", value)}
            />
            <div className="flex flex-row justify-stretch space-x-6">
                <TextInput
                  id="city"
                  label="Localité"
                  disabled={disabled}
                  value={address.city}
                  placeholder={placeholders[1]}
                  error={errors[1]}
                  required={required}
                  onChange={value => handleChange("city", value)}
                />
                <TextInput
                  id="codePostal"
                  label="Code postal"
                  disabled={disabled}
                  value={address.postalCode}
                  placeholder={placeholders[2]}
                  error={errors[2]}
                  required={required}
                  onChange={value => handleChange("postalCode", value)}
                />
            </div>
            <SelectInput
              id="country"
              label="Pays"
              options={countries}
              disabled={disabled}
              value={address.country}
              placeholder={placeholders[3]}
              error={errors[3]}
              required={required}
              onChange={value => handleChange("country", value)}
            />
        </div>
    );
}
